import { createResource } from '../utils/resource'

const certificationAuthorityStore = createResource('certificationAuthority', {})

export default certificationAuthorityStore
